import { render, staticRenderFns } from "./EditMatchTutorial.vue?vue&type=template&id=0c34c877&scoped=true&"
import script from "./EditMatchTutorial.vue?vue&type=script&lang=js&"
export * from "./EditMatchTutorial.vue?vue&type=script&lang=js&"
import style0 from "./EditMatchTutorial.vue?vue&type=style&index=0&id=0c34c877&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c34c877",
  null
  
)

export default component.exports